module.exports = __webpack_public_path__ + "img/prilosec_otc_tablets.034fd2c5.jpeg";